import TableVM from '../table-vm';
import GradebookServices from '../services';
export default Kadenze.Util.extendObj(TableVM, function() {
  var self = this;
  self.$el = $('#grades-tab-content');
  self.filter_options = ko.observable({'submissions': ['ungraded', 'partially_graded', 'not_submitted', 'submitted', 'student_action_required']});
  if (Kadenze.isKadenze)
    self.filter_options()['students'] = ['auditor', 'certificate'];
  self.params = {
    filters: ko.observableArray([]),
    page: ko.observable(1),
    page_size: ko.observable(20),
    search: ko.observable(''),
    student_sort: ko.observable('ASC'),
    coursework_sort: ko.observable('type'),
    gtd_mode: ko.observable('standard')
  };
  self.coursework_ids = ko.observableArray([]);
  self.courseworks = ko.observableArray();
  self.coursework_families = ko.observableArray();
  self.student_ids = ko.observableArray([]);
  self.students = ko.observableArray([]);
  self.gtd_mode = ko.observable('standard');
  self.show_attendance = ko.observable(false);
  self.initUI = function () {
    var $searchEl = $('#gradesSearch');
    $searchEl.on('keypress', function(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13') {
        $searchEl.blur();
      }
    });
  };

  self.bindFilters = function () {
    _.each(_.keys(self.params), function (key) {
      self.params[key].subscribe(self.filterChanged, self);
    });
  };

  self.getSheet = function(url, params) {
    params = params ? params : ko.mapping.toJS(self.params);
    url = url ? url : Kadenze.Routes.course_gradebook_grades_path(self.course_id, params);

    self.students([]);

    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      timeout: 60000,
      beforeSend: function (xhr, settings) {
        self.request_pool.add(xhr);
      }
    });

    request.done(function(data) {
      self.bindData(data);
    });

    request.fail(function(xhr, textStatus, message) {
      if (textStatus == 'abort') {
        return;
      }
      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
      console.warn('Error retrieving sheet data:', xhr);
    });

    request.always(function(data) {
      Kadenze.PaginationBinding.applyBindingsWithTextInput(self.pageChanged.bind(self));
    });

    return request;
  };

  self.bindData = function(data) {
    if (self.params.coursework_sort() == 'type') {
      var mapped_coursework_families = ko.mapping.fromJS(data.coursework_families);
      self.coursework_families(mapped_coursework_families());
    } else {
      var mapped_courseworks = ko.mapping.fromJS(data.courseworks);
      self.courseworks(mapped_courseworks());
    }

    self.student_ids(data.student_ids);
    self.coursework_ids(data.coursework_ids);

    self.paginator(data.paginator);
    self.show_attendance(data.show_attendance);

    if (self.student_ids().length > 0) {
      self.mp = new Mprogress({
        template: 1,
        start: true,
        parent: '#' + self.$el.attr('id') + ' .gradesheet-table'
      });

      _.each(self.student_ids(), function(student_id) {
        self.getStudent(student_id);
      });

      self.hidePlaceholder();
    } else {
      self.showPlaceholder('no_results');
    }
  };

  self.getStudent = function(student_id) {
    var url = Kadenze.Routes.index_row_course_gradebook_grades_path(self.course_id, student_id, {coursework_sort: self.params.coursework_sort(), coursework_ids: self.coursework_ids()});

    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      data: null,
      timeout: 60000,
      beforeSend: function (xhr, settings) {
        self.request_pool.add(xhr);
      }
    });

    request.done(function(data) {
      var mapped_student = ko.mapping.fromJS(data.student);
      self.students.push(mapped_student);

      var completion = self.students().length / self.student_ids().length;
      self.mp.set(completion);
      if (completion == 1) {
        self.mp.end();

        // add dropdown listeners
        var $dropDowns = self.$el.find('.js-table-dropdown');
        $dropDowns.on('shown.bs.dropdown', function () {
          var $menu = $(this);
          self.updateMenuPosition($menu);
        });
      }
    });

    request.fail(function(xhr, textStatus, message) {
      if (textStatus == 'abort') {
        return;
      }
      console.log('Error retrieving row data:', xhr);
    });
  };

  self.findStudent = function(student_id) {
    return _.find(self.students(), function (student) {
      return student.id() == student_id;
    });
  };

  self.exportTable = function () {
    var url = Kadenze.Routes.export_course_gradebook_grades_path(self.course_id, ko.mapping.toJS(self.params));
    GradebookServices.sendRequest(url, 'POST', self.$el);
    Kadenze.Analytics.track('grade', 'download', {type: 'global_grades'});
  };

  self.toggleCourseworkView = function () {
    if (self.params.coursework_sort() == 'type') {
      self.params.coursework_sort('date');
    } else {
      self.params.coursework_sort('type');
    }
  };

  self.toggleStudentSort = function () {
    if (self.params.student_sort() == 'ASC') {
      self.params.student_sort('DESC');
    } else {
      self.params.student_sort('ASC');
    }
  };

  self.toggleGTDMode = function () {
    if (self.gtd_mode() == 'standard') {
      self.gtd_mode('presumptive');
      self.params.gtd_mode('presumptive');
    } else {
      self.gtd_mode('standard');
      self.params.gtd_mode('standard');
    }
    self.$el.click(); //Hack to close selectpicker & menus
  };

  self.resolveAllGrades = function (item, event) {
    var msg = I18n.t('js.resolve_all_grades_message');
    Kadenze.UIUtil.confirmAction(msg, function () {
      var url = Kadenze.Routes.resolve_course_gradebook_grades_path(self.course_id);
      GradebookServices.sendRequest(url, 'POST', self.$el);
    });
    self.$el.click(); //Hack to close selectpicker & menus
  };

  self.resolveCourseworkGrades = function (item, event) {
    var msg = 'This action will apply a 0% grade to all unsubmitted coursework in {coursework}. '.supplant({coursework: item.name()}) +
        'Individual student grades can be updated/changed later. Are you sure you want to continue?';
    Kadenze.UIUtil.confirmAction(msg, function () {
      var url = Kadenze.Routes.resolve_coursework_course_gradebook_grades_path(self.course_id, item.id());
      GradebookServices.sendRequest(url, 'POST', self.$el);
    });
  };

  self.postAllGrades = function(item, event) {
    var msg = I18n.t('js.post_grades_message');
    Kadenze.UIUtil.confirmAction(msg, function () {
      var url = Kadenze.Routes.course_coursework_post_all_grades_path(self.course_id, item.id());
      GradebookServices.sendRequest(url, 'PATCH', self.$el).done(function(data){
        self.getSheet();
      });
    });
  };

  self.draftAllGrades = function(item, event) {
    var msg = I18n.t('js.draft_grades_message');
    Kadenze.UIUtil.confirmAction(msg, function () {
      var url = Kadenze.Routes.course_coursework_draft_all_grades_path(self.course_id, item.id());
      GradebookServices.sendRequest(url, 'PATCH', self.$el).done(function(data){
        self.getSheet();
      });
    });
  };

  self.resolveGrade = function (item, event) {
    var url = Kadenze.Routes.resolve_coursework_student_course_gradebook_grades_path(self.course_id, item.id(), item.student_id());
    GradebookServices.sendRequest(url, 'POST', self.$el);
  };

  self.gradeForStudent = function(item, msg) {
    Kadenze.UIUtil.confirmAction(msg, function () {
      var url = Kadenze.Routes.course_coursework_post_or_draft_grade_path(self.course_id, item.id());
      var request = new Kadenze.AjaxRequest({
        url: url,
        type: 'PATCH',
        data: {student_id: item.student_id()},
        loadingIndicator: {
          container: self.$el
        }
      });
      request.done(function(response, status, xhr) {
        self.showRowData(self.course_id, response.grade.coursework_id, response.grade.user_id, item);
        new Kadenze.Notice.success({message: response.message});
      });
      request.fail(function(data) {
        new Kadenze.Notice.error({message: I18n.t('js.error_message')});
      });
    });
  };

  self.postGradeForStudent = function(item, event) {
    var msg = I18n.t('js.post_grade_message');
    self.gradeForStudent(item, msg);
  };

  self.draftGradeForStudent = function(item, event){
    var msg = I18n.t('js.draft_grade_message');
    self.gradeForStudent(item, msg);
  };

  self.markAsSubmitted = function (item, event) {
    GradebookServices.markAs(item, event, 'submitted');
  };

  self.markAsUnsubmitted = function (item, event) {
    GradebookServices.markAs(item, event, 'unsubmitted');
  };

  self.showSpeedGrader = function (item, event) {
    GradebookServices.initSpeedGrader({coursework_data: {id: item.id}, student_data: {id: item.student_id}}, event, self.params.filters(), function () {
      //Refresh coursework row after close
      self.showRowData(self.course_id, item.id(), item.student_id(), item);
    });
    event.stopImmediatePropagation();
  };

  self.showRowData = function(courseId, courseworkId, studentId, item){
    var url = Kadenze.Routes.show_row_course_gradebook_grades_path(courseId, courseworkId, studentId);
    GradebookServices.sendRequest(url, 'GET', self.$el).done(function (data) {
      _.each(_.keys(data), function (key) {
        if (ko.isObservable(item[key]))
          item[key](data[key]);
      });
    });
  };

  const __construct = function(that) {
    console.log('constructor called for Kadenze.InstructorGradebook.GradesViewModel');
    that.course_id = $('#course_id').val();
    that.showPlaceholder('loading');
    that.getSheet();
    that.bindFilters();
  }(this);
});

